import { HomeService } from '../../services/homeService';
import { createPageStore } from '../pageStore';

const homeService = new HomeService();

const fetchData = async (): Promise<Object> => {
  return await homeService.getDashboardExtra();
};

export const useHomeDashboardExtraStore = createPageStore(fetchData);
